(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-wc-commerce]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.closest('form');
      const select = root.querySelector('[data-wc-model-select]');
      const button = root.querySelector('[data-wc-submit]');
      const label = root.querySelector('[data-wc-submit-label]');
      const summary = root.querySelector('[data-wc-selection]');
      const name = root.querySelector('[data-wc-selection-name]');
      const error = root.querySelector('[data-wc-form-error]');
      let busy = false;
      let uncertain = false;
      let added = false;
      const update = () => {
        const option = select.selectedOptions[0];
        const valid = Boolean(select.value) && !option?.disabled;
        button.disabled = busy || !valid || uncertain;
        label.textContent = busy ? root.dataset.adding : valid ? root.dataset.readyLabel : root.dataset.selectLabel;
        summary.hidden = !valid;
        name.textContent = valid ? `${option.textContent.trim()} · ${option.dataset.price}` : '';
      };
      select.addEventListener('change', update);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || uncertain || !form.reportValidity() || !select.value || select.selectedOptions[0]?.disabled) return;
        busy = true;
        error.hidden = true;
        root.setAttribute('aria-busy', 'true');
        update();
        const body = new FormData(form);
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 25000);
        try {
          const response = await fetch(root.dataset.addUrl, {
            method: 'POST', body, signal: controller.signal,
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            uncertain = true;
            root.querySelector('[data-wc-error-text]').textContent = data.description || root.dataset.error;
            error.hidden = false;
            error.querySelector('a').focus();
            return;
          }
          added = true;
          window.location.assign(root.dataset.cartUrl);
        } catch {
          uncertain = true;
          root.querySelector('[data-wc-error-text]').textContent = root.dataset.error;
          error.hidden = false;
          error.querySelector('a').focus();
        } finally {
          window.clearTimeout(timer);
          busy = added;
          root.setAttribute('aria-busy', added ? 'true' : 'false');
          update();
        }
      });
      update();
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        busy = false;
        uncertain = false;
        added = false;
        root.setAttribute('aria-busy', 'false');
        update();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
